<template>
  <div
    v-if="item && item.isShow === 1 && arrContent && arrContent.length > 0"
    class="mode3-box relative"
    :class="[IsMobile ? 'IsMobile' : '']"
  >
    <i
      v-if="cur_left > 0"
      @click="cur_left > 0 ? changePosition('left') : ''"
      :class="cur_left > 0 ? '' : 'disabled'"
      class="icon-arrow-common el-icon-arrow-left"
    ></i>

    <i
      v-if="cur_left < max_left - 1"
      :class="cur_left < max_left - 1 ? '' : 'disabled'"
      @click="cur_left < max_left - 1 ? changePosition('right') : ''"
      class="icon-arrow-common el-icon-arrow-right"
    ></i>

    <div style="overflow: hidden">
      <div class="content" :class="`content_${content_index}`">
        <template v-for="(item, i) in arrContent">
          <div :key="i" class="content-box relative">
            <el-skeleton :loading="skeletonLoading" animated :throttle="0">
              <template slot="template">
                <el-skeleton-item variant="image" style="width: 100%" :style="{ height: $px2rem(getImgHeight) }" />
              </template>
              <template>
                <img
                  class="content-img"
                  v-if="$utils.returnImgUrl($utils.lang_data(lang, item, 'langInfoObj')?.bannerIcon) && !$utils.isMp4($utils.lang_data(lang, item, 'langInfoObj')?.bannerIcon)"
                  :src="$utils.returnImgUrl($utils.lang_data(lang, item, 'langInfoObj')?.bannerIcon)"
                  alt
                  style="display: block"
                />
                <div class="content-img" v-if="$utils.isMp4($utils.lang_data(lang, item, 'langInfoObj')?.bannerIcon)">
                  <img
                    class="preloadImg"
                    style="width: 100%"
                    v-if="showPoster"
                    :src="$utils.returnImgUrl($utils.lang_data(lang, item, 'langInfoObj')?.preloadImg)"
                    alt
                  />
                  <video
                    autoplay
                    muted
                    loop
                    playsinline
                    id='background-video1'
                    class="background-video"
                    style="width: 100%;"
                    v-show="!showPoster"
                    @canplay="showPoster = false;"
                  >
                    <source :src="$utils.returnImgUrl($utils.lang_data(lang, item, 'langInfoObj')?.bannerIcon)" type="video/mp4" />
                  </video>
                </div>
                <div class="mode3-btn-box">
                  <!-- <div style="width: 260px; margin-bottom: 0px" v-html="item.langInfoObj[lang]?.content"></div> -->
                  <div class="content-desc" v-html="$utils.lang_data(lang, item, 'langInfoObj')?.desc"></div>
                  <div
                    v-if="$utils.lang_data(lang, item, 'langInfoObj')?.btuName"
                    class="content-btn"
                    v-exposure="{ eid: item.eid, jump_value: item.jump }"
                    :data-id="item.eid"
                    @click="handelClick(item)"
                  >
                    <!-- <img :src="$utils.returnImgUrl(item.langInfoObj[lang]?.btuIcon)" alt style="display: block; width: 100%; height: 100%;" v-if='item.langInfoObj[lang]?.btuIcon'/> -->
                    <div class="btnTxtDiv">
                      {{ $utils.lang_data(lang, item, "langInfoObj")?.btuName || "" }}
                    </div>
                  </div>
                </div>
              </template>
            </el-skeleton>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import mode3 from "@/lobby_common/mixins_views/homeModule/mode3.js";
export default {
  mixins: [mode3],
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  display: flex;
}
.content-box {
  flex-shrink: 0;
  overflow: hidden;
  word-break: break-all;
  width: 100%;
  margin-right: 0%;
  img {
    width: 100%;
    border-radius: 5px;
  }
  .mode3-btn-box {
    // width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    position: absolute;
    left: 50%;
    bottom: 20px;
    top: 0px;
    .content-desc {
      margin-bottom: 20px;
      overflow: hidden;
    }
    .content-btn {
      min-width: 200px;
      height: 52px;
      line-height: 52px;
      margin-left: 30px;
      position: relative;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      @include buttonPrimary;
      border-radius: var(--radius-100);
      .btnTxtDiv {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.content-box.mr-0 {
  margin-right: 0%;
}

.el-icon-arrow-left {
  width: 30px;
  position: absolute;
  left: -35px;
  top: 50%;
  margin-top: -15px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}
.el-icon-arrow-right {
  width: 30px;
  position: absolute;
  right: -35px;
  top: 50%;
  margin-top: -15px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}
.mode3-box {
  &.IsMobile {
    .mode3-btn-box {
      position: absolute;
      left: 0px;
      top: 0px;
      font-size: 12px;
      width: 100%;
      height: 100%;
      .content-desc {
        margin-left: 36px;
        margin-bottom: 10px;
        overflow: hidden;
      }
      .content-btn {
        min-width: 80px;
        height: 28px;
        margin-left: unset;
        padding: 0 8px;
        line-height: 28px;
        font-size: 12px;
        margin-bottom: 10px;
        align-self: center;
      }
    }
    .el-icon-arrow-left {
      left: 0;
    }
    .el-icon-arrow-right {
      right: 0;
    }
  }
}
</style>
